<script setup lang="ts">
import { useI18n } from "vue-i18n";
import Button from "primevue/button";
import { i18n } from "../../main.ts";

const { t } = useI18n();

function openWebsite(link: string) {
    globalThis.open(link, "_blank");
}

const openConsultationLink = () => {
    globalThis.open(t('accessibility.consultation.url'), '_blank', 'noopener,noreferrer');
};
</script>

<template>
    <div class="grid grid-cols-12 gap-4 app-wrapper" style="min-height: 40vh">
        <div class="md:col-span-6 col-span-12 text-secondary p-8 pl-0 my-auto" id="introduction_div_heading">
            <TitleHeadline :title="t('home.heading')" :subtitle="t('home.subHeading')" :top-margin="0" />
            <p>{{ t("home.introduction.text") }}</p>
            <ul class="custom-list">
                <li>{{ t("home.introduction.feature1") }}</li>
                <li>{{ t("home.introduction.feature2") }}</li>
                <li>{{ t("home.introduction.feature3") }}</li>
                <li>{{ t("home.introduction.feature4") }}</li>
                <li>{{ t("home.introduction.feature5") }}</li>
            </ul>
            <div class="mt-6">
                <Button
                    class="consultation-btn font-bold"
                    icon="pi pi-external-link"
                    iconPos="right"
                    :label="t('accessibility.consultation.arrangeConsultation')"
                    :aria-label="t('accessibility.consultation.arrangeConsultation') + ' ' + t('accessibility.links.externalLink')"
                    @click="openConsultationLink"
                />
            </div>

        </div>
        <div class="md:col-span-6 col-span-12 bg-white p-8 my-auto" id="introduction_div_newsletter">
            <TitleHeadline
                :title="t('home.news.heading')"
                :subtitle="t('home.news.subHeading')"
                heading-type="h2"
                :top-margin="0"
            />
            <h4 class="text-secondary">{{ t("home.news.highlight") }}</h4>
            <p class="text-secondary mb-6">{{ t("home.news.text.recommendation") }}</p>
            <p class="text-secondary mb-6" v-html="t('home.news.text.action')"></p>
            <Button
                :label="t('home.news.button')"
                icon="pi pi-bell"
                @click="openWebsite(i18n.global.locale.value === 'de' ? 'https://persolog.com/de/blog/online-world-update/?utm_source=persolog.online&utm_medium=anzeige' : 'https://persolog.com/blog/online-world-update/?utm_source=persolog.online&utm_medium=anzeige')"
            />
        </div>
    </div>
</template>

<style scoped>
ul.custom-list {
    list-style-type: none;
    padding-left: 1rem;
}

ul.custom-list li {
    position: relative;
    padding-left: 1.5em;
}

ul.custom-list li::before {
    content: "\e909";
    font-family: "PrimeIcons", serif;
    position: absolute;
    left: 0;
    top: 0.1em;
}
</style>
